/**
 * Re-export WordPress's jQuery so the theme bundle does not ship a second copy.
 * wp_enqueue_script must list 'jquery' as a dependency for the main bundle.
 */
export default window.jQuery;
